(function () {
  const root = document.querySelector('[data-assembly-guides]');
  if (!root) return;

  const searchInput = root.querySelector('[data-assembly-search]');
  const filters = Array.from(root.querySelectorAll('[data-assembly-filter]'));
  const groups = Array.from(root.querySelectorAll('[data-assembly-group]'));
  const cards = Array.from(root.querySelectorAll('[data-assembly-card]'));
  const noResults = root.querySelector('[data-assembly-no-results]');
  const params = new URLSearchParams(window.location.search);
  const requestedFilter = params.get('losning') || params.get('filter') || 'all';
  const hasRequestedFilter = filters.some(function (button) {
    return (button.dataset.assemblyFilter || 'all') === requestedFilter;
  });

  let activeFilter = hasRequestedFilter ? requestedFilter : 'all';

  function normalize(value) {
    return (value || '').toString().toLowerCase().trim();
  }

  function setActiveFilter(nextFilter) {
    activeFilter = nextFilter || 'all';

    filters.forEach(function (button) {
      const isActive = (button.dataset.assemblyFilter || 'all') === activeFilter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const nextUrl = new URL(window.location.href);
    if (activeFilter === 'all') {
      nextUrl.searchParams.delete('losning');
      nextUrl.searchParams.delete('filter');
    } else {
      nextUrl.searchParams.set('losning', activeFilter);
      nextUrl.searchParams.delete('filter');
    }
    window.history.replaceState({}, '', nextUrl);
  }

  function updateVisibility() {
    const query = normalize(searchInput ? searchInput.value : '');
    let visibleCount = 0;

    cards.forEach(function (card) {
      const groupHandle = card.dataset.solution || '';
      const matchesFilter = activeFilter === 'all' || groupHandle === activeFilter;
      const matchesQuery = !query || normalize(card.dataset.search).indexOf(query) !== -1;
      const isVisible = matchesFilter && matchesQuery;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    groups.forEach(function (group) {
      const hasVisibleCard = group.querySelector('[data-assembly-card]:not([hidden])');
      group.hidden = !hasVisibleCard;
    });

    if (noResults) {
      noResults.hidden = visibleCount > 0;
    }
  }

  filters.forEach(function (button) {
    button.addEventListener('click', function () {
      setActiveFilter(button.dataset.assemblyFilter || 'all');
      updateVisibility();

      if (activeFilter === 'all') return;

      const target = root.querySelector('[data-assembly-group="' + activeFilter + '"]');
      if (target && !target.hidden) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', updateVisibility);
  }

  setActiveFilter(activeFilter);
  updateVisibility();
})();
